import React, { Component } from 'react';

import { Row, Col, Button, Alert, Container, Label } from "reactstrap";

// Redux
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';

// availity-reactstrap-validation
import { AvForm, AvField } from 'availity-reactstrap-validation';

// actions
import { checkLogin, apiError } from '../../store/actions';

// import images
import logodark from "../../assets/images/Planmans.png";
import logolight from "../../assets/images/Planmans.png";
// import jwt_decode from "jwt-decode";
import { BaseUrl } from '../../helpers/Baseurl';


class Login extends Component {

    constructor(props) {
        super(props);
        if (localStorage.getItem("authUser")) {
            this.props.history.push('/dashboard');  
        }
        this.state = { username: "", password: "", error : null}
        

        this.handleSubmit = this.handleSubmit.bind(this);
        
    } 
     handleSubmit(event, values) {
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(values)
        };   
        try{
            fetch(`${BaseUrl}/api/accounts/login/`,requestOptions)
            .then(res => 
                {if(res.status >= 404){
                    res.json()
                    .then(
                        (data) =>{ this.setState({error: data.detail }) }
                    )
                }
                else{
                    res.json()
                    .then(
                        (data) =>{
                        localStorage.setItem("authUser", JSON.stringify(data));
                        localStorage.setItem("user_permission", JSON.stringify(true)); 
                        this.props.history.push('/dashboard');
                        }
                    )
                }    
            }
        )

        }catch(error){
            console.log(error)
            this.setState({
            error: "somthing Went Wrong"
            });
        }

        

    }

    componentDidMount() {
        this.props.apiError("");
        document.body.classList.add("auth-body-bg");
    }

    componentWillUnmount() {
        document.body.classList.remove("auth-body-bg");
    }

    render() {
        

        return (
            <React.Fragment>
                <div>
                    <Container fluid className="p-0">
                        <Row className="g-0">
                            <Col lg={4}>
                                <div className="authentication-page-content p-4 d-flex align-items-center min-vh-100">
                                    <div className="w-100">
                                        <Row className="justify-content-center">
                                            <Col lg={9}>
                                                <div>
                                                    <div className="text-center">
                                                    <div>
                                                        <Link to="/" class="">
                                                            <img src={logodark} alt=""  style={{maxwidth:`100%`, width:`250px`}} class="auth-logo logo-dark mx-auto" />
                                                            <img src={logolight} alt="" style={{maxwidth:`100%`, width:`250px`}} class="auth-logo logo-light mx-auto" />
                                                        </Link>
                                                    </div>

                                                        <h4 className="font-size-18 mt-4">Welcome Back !</h4>
                                                        <p className="text-muted">Sign in to continue to Planman</p>
                                                    </div>


                                                    {this.state.error ? <Alert color="danger">{this.state.error}</Alert> : null}

                                                    <div className="p-2 mt-5">
                                                        <AvForm className="form-horizontal" onValidSubmit={this.handleSubmit} >

                                                            <div className="auth-form-group-custom mb-4">
                                                                <i className="ri-user-2-line auti-custom-input-icon"></i>
                                                                <Label htmlFor="username">Email</Label>
                                                                <AvField name="email" value={''} type="text" className="form-control" id="username" validate={{ email: true, required: true }} placeholder="Enter username" />
                                                            </div>

                                                            <div className="auth-form-group-custom mb-4">
                                                                <i className="ri-lock-2-line auti-custom-input-icon"></i>
                                                                <Label htmlFor="userpassword">Password</Label>
                                                                <AvField name="password" value={''} type="password" className="form-control" id="userpassword" placeholder="Enter password" />
                                                            </div>
                                                            
                                                            <div className="mt-4 text-center">
                                                                <Button color="primary" className="w-md waves-effect waves-light" type="submit">Log In</Button>
                                                            </div>

                                                        </AvForm>
                                                    </div>

                                                    <div className="mt-5 text-center">
                                                       
                                                        <p>© 2024 <a href='https://planman.in/' target='_blank'>planman.in</a></p>
                                                    </div>
                                                </div>

                                            </Col>
                                        </Row>
                                    </div>
                                </div>
                            </Col>
                            <Col lg={8}>
                                <div className="authentication-bg">
                                    <div className="bg-overlay"></div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </React.Fragment>
        );
    }
}

const mapStatetoProps = state => {
    const { loginError } = state.Login;
    return { loginError };
}

export default withRouter(connect(mapStatetoProps, { checkLogin, apiError })(Login));